import React, {useCallback, useEffect, useState} from 'react';
import {Box, CircularProgress, Typography} from "@mui/material";
import {useHistory, useLocation} from "react-router-dom";
import {AuthService} from "../services/AuthService";
import { Route } from 'react-router-dom';
import AdminPortal from "./AdminPortal";
import {useAuthCheckAuthenticated, useAuthLogoutMutation} from "../api-services/user/authenticationApi";
import {useAppDispatch} from "../app/hooks";

const AuthenticatedRoutes = (props: any) => {
  const dispatch = useAppDispatch()

  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [hasCheckedAuthentication, toggleAuthenticationCheck] = useState<boolean>(false);
  // 828 const [loginSession] = useState<AuthSession>(AuthService.getLoginSession());

  const history = useHistory();
  const goTo = useCallback((location: string): void => {
    history.push(location);
  }, [history]);

  let redirectPath: string = '/app/dashboard'
  const location = useLocation();
  if (location) {
    redirectPath = location.pathname
  }

  const [apiCheckAuthenticated, { isLoading }] = useAuthCheckAuthenticated()
  const [apiLogout, { isLoading: loggingOut }] = useAuthLogoutMutation()

  const handleCheckAuthenticated = (): void => {
    apiCheckAuthenticated()
      .unwrap()
      .then((response) => {
        setIsAuthenticated(response.isAuthenticated)
        toggleAuthenticationCheck(true)
      })
      .catch(async () => {
        handleLogout()
      })
  }

  const handleLogout = (): void => {
    apiLogout()
      .unwrap()
      .then(() => {
        AuthService.logout();
        goTo('/auth/login')
      })
      .catch((err) => {
        goTo('/auth/login')
      })
  }

  useEffect(() => {
    if (!hasCheckedAuthentication) {
      handleCheckAuthenticated()
    }

    if (hasCheckedAuthentication) {
      if (!isAuthenticated) {
        handleLogout()
      }
      else {
        goTo(redirectPath);
      }
    }
  }, [
    hasCheckedAuthentication, isAuthenticated
  ])

  return (
    <React.Fragment>
      {!hasCheckedAuthentication && !isAuthenticated &&
	      <Box sx={{display: 'flex', flexGrow: 1, height: '100%', position: 'absolute', width: '100%'}} alignItems={'center'} justifyContent={'center'} flexDirection={'column'}>
		      <CircularProgress variant={'indeterminate'} sx={{mb: 2}} />
		      <Typography variant={'body1'}>Initialising Admin Portal</Typography>
	      </Box>
      }

      {hasCheckedAuthentication && isAuthenticated &&
	      <Route exact={false} path={'/app'}>
		      <AdminPortal />
	      </Route>
      }
    </React.Fragment>
  )
}

export default AuthenticatedRoutes;
